import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SectionTitle from "../SectionTitle/SectionTitle";
import { Link, useNavigate } from "react-router-dom";
import { mergeClasses } from "../../utils";

const settings = {
  dots: false,
  arrows: true,
  speed: 500, // transition speed
  slidesToShow: 5,
  slidesToScroll: 5,
  autoplay: true,
  autoplaySpeed: 8000, // increased autoplay speed (8 seconds)
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
      },
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      },
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      },
    },
    {
      breakpoint: 376,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      },
    },
    {
      breakpoint: 175,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      },
    },
  ],
};

// Helper to chunk array into groups of 4
function chunkArray(arr, size) {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}

const Categorys = ({
  showTitle = true,
  className,
  innerClassName,
  ...props
}) => {
  const navigate = useNavigate();

  const handleCategoryClick = (category) => {
    const searchParams = new URLSearchParams();
    searchParams.set("category", category);
    navigate(`/shop?${searchParams.toString()}`);
  };

  // Detect mobile
  const isMobile = window.innerWidth <= 767;
  const categories = props?.configs?.categories || [];

  // Chunk categories for mobile
  const mobileChunks = isMobile ? chunkArray(categories, 4) : [];

  return (
    <section className={mergeClasses("featured-section sm-separator-padding pb-0", className)}>
      <div className={mergeClasses("sm-container", innerClassName)}>
        {showTitle && (
          <div className="row">
            <div className="col-lg-6">
              <SectionTitle sTitle={"Featured Categories"} />
            </div>
          </div>
        )}
        <div className="featured-category-slider featured-category-slider-active">
          <Slider {...settings}>
            {isMobile
              ? mobileChunks.map((chunk, idx) => (
                  <div key={idx}>
                    <div
                      className="mobile-category-grid"
                      style={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 16,
                        justifyContent: "center",
                      }}
                    >
                      {chunk.slice(0, 2).map((category, catIdx) => (
                        <div
                          className="featured-item"
                          key={catIdx}
                          onClick={() => handleCategoryClick(category?.name)}
                          style={{
                            flex: "0 0 48%",
                            boxSizing: "border-box",
                            marginBottom: 16,
                            minWidth: 140,
                            maxWidth: "48%",
                          }}
                        >
                          <div className="icon" style={{ cursor: "pointer" }}>
                            <img
                              src={category?.url}
                              className="icon-image"
                              alt={category?.name}
                              style={{ width: "100%", height: "auto", display: "block" }}
                            />
                          </div>
                          <div className="text" style={{ textAlign: "center" }}>
                            <h2 style={{ fontSize: 16, margin: "8px 0" }}>
                              <button
                                className="link-button"
                                style={{ background: "none", border: "none", padding: 0, color: "#333" }}
                                onClick={() => handleCategoryClick(category?.name)}
                              >
                                {category?.name}
                              </button>
                            </h2>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              : categories.map((category, cat) => (
                  <div className="featured-item" key={cat} onClick={() => handleCategoryClick(category?.name)}>
                    <div className="icon" style={{ cursor: "pointer" }}>
                      <img src={category?.url} className="icon-image" alt={category?.name} />
                    </div>
                    <div className="text">
                      <h2>
                        <button
                          className="link-button"
                          onClick={() => handleCategoryClick(category?.name)}
                        >
                          {category?.name}
                        </button>
                      </h2>
                    </div>
                  </div>
                ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default Categorys;
